import type { CSSProperties } from 'react';

/**
 * High flex orders for the non-reorderable closing tail (legal disclaimer,
 * theme footer). Pins these blocks after all studio sections when page
 * shells flatten to `display: contents`.
 */
export const CLOSING_TAIL_BASE_FLEX_ORDER = 99999;
export const LEGAL_DISCLAIMER_FLEX_ORDER = CLOSING_TAIL_BASE_FLEX_ORDER;
export const THEME_FOOTER_FLEX_ORDER = CLOSING_TAIL_BASE_FLEX_ORDER + 1;

export function resolveLegalDisclaimerTailStyle(flatten: boolean): CSSProperties {
  return flatten ? { order: LEGAL_DISCLAIMER_FLEX_ORDER } : {};
}

export function resolveThemeFooterTailStyle(flatten: boolean): CSSProperties {
  return flatten ? { order: THEME_FOOTER_FLEX_ORDER } : {};
}
